import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { RiLink } from "@remixicon/react";

interface EasyAnchorLinkProps {
  id: string;
  tooltip?: string;
  size?: "small" | "medium" | "large";
  onCopy?: () => void;
}

const EasyAnchorLink: React.FC<EasyAnchorLinkProps> = ({
  id,
  tooltip = "Copy link",
  size = "small",
  onCopy,
}) => {
  const copyToClipboard = () => {
    const url = `${window.location.origin}${window.location.pathname}${window.location.search}#${id}`;
    navigator.clipboard.writeText(url).then(() => {
      if (onCopy) {
        onCopy();
      }
    });
  };

  return (
    <Tooltip title={tooltip}>
      <IconButton onClick={copyToClipboard} size={size}>
        <RiLink />
      </IconButton>
    </Tooltip>
  );
};

export default EasyAnchorLink;
